// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import React from 'react'
import { connect } from 'react-redux'
import { Table, Row, Col, Button, Card, Tag, Modal, message } from 'antd'
import EditUserModal from './EditUserModal'
import { values } from 'lodash'

class Admin extends React.Component {
  componentDidMount () {
    const { fetchUsers } = this.props
    fetchUsers({
      page: 1,
      pageSize: 99999
    })
  }

  handleChangePage = (current, pageSize) => {
    const { setPagination } = this.props
    setPagination({
      current,
      pageSize
    })
  }

  handleAddUser = () => {
    this.props.setEditModalVisible({ visible: true, actionType: 'create' })
  }

  handleClickModify = user => {
    this.props.setEditModalVisible({ visible: true, actionType: 'edit' })
    this.props.setEditingUser(user)
  }

  handleModalCancel = () => {
    this.props.setEditModalVisible({ visible: false })
  }

  handleModalOk = value => {
    const { editingUser, modifyUser, actionType, addUser } = this.props
    if (actionType === 'edit') {
      modifyUser({
        ...editingUser,
        ...value
      })
    } else {
      addUser(value)
    }
  }

  handleClickDelete = user => {
    const { deleteUser } = this.props
    Modal.confirm({
      title: 'Do you want to delete this user?',
      content: '',
      onOk () {
        deleteUser(user.id)
      }
    })
  }

  _renderTitle = () => {
    return (
      <Row type='flex' justify='space-between'>
        <Col>User management</Col>
        <Col>
          <Button onClick={this.handleAddUser} type='primary'>
            Add user
          </Button>
        </Col>
      </Row>
    )
  }

  render () {
    const { loading, users, pagination, isEditModalVisible, modifyLoading, editingUser, roles, actionType } = this.props
    const columns = [
      {
        title: 'Id',
        dataIndex: 'id'
      },
      {
        title: 'Email',
        dataIndex: 'email'
      },
      {
        title: 'Name',
        dataIndex: 'name'
      },
      {
        title: 'Role',
        render: (text, d) =>
          d.role_ids.map(id => (
            <Tag key={id} style={{ marginRight: 5 }}>
              {roles[id].name}
            </Tag>
          ))
      },
      {
        title: 'Action',
        render: (t, d, i) => {
          // if (d.id === currentUser.id) {
          //   return null
          // }
          return (
            <div>
              <Button onClick={() => this.handleClickModify(d)} type='link'>
                Modify
              </Button>
              <span>|</span>
              <Button onClick={() => this.handleClickDelete(d)} type='link'>
                Delete
              </Button>
            </div>
          )
        }
      }
    ]
    return (
      <div style={{ paddingTop: 64 }}>
        <div style={{ padding: 20 }}>
          <Card title={this._renderTitle()}>
            <Table
              columns={columns}
              dataSource={users}
              loading={loading}
              rowKey={d => d.id}
              pagination={{
                onChange: this.handleChangePage,
                ...pagination
              }}
            />
          </Card>
          {isEditModalVisible && (
            <EditUserModal
              actionType={actionType}
              user={editingUser}
              onOk={this.handleModalOk}
              onCancel={this.handleModalCancel}
              roles={values(roles)}
              modifyLoading={modifyLoading}
            />
          )}
        </div>
      </div>
    )
  }
}
export default connect(
  state => ({ ...state.admin, currentUser: state.auth.userInfo }),
  dispatch => dispatch.admin
)(Admin)
